enum DayLaborer {
  NONE = 'None',
  DAYS = 'Days',
  HOURS = 'Hours',
}

export default DayLaborer
